import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LayoutComponent } from './components/layout/layout.component';
import { BookingComponent } from './components/booking/booking.component';
import { UserComponent } from './components/user/user.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FinanceOverviewComponent } from './components/finance-overview/finance-overview.component';
import { HelpsupportComponent } from './components/helpsupport/helpsupport.component';
import { NgChartsModule } from 'ng2-charts';
import { Router } from '@angular/router';
import { SettingsComponent } from './components/settings/settings.component';
import { PersonaldetailsComponent } from './components/personaldetails/personaldetails.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { ContenManagerComponent } from './components/conten-manager/conten-manager.component';
import { SubsettingComponent } from './components/subsetting/subsetting.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { PreferenceComponent } from './components/preference/preference.component';
import { SecurityComponent } from './components/security/security.component';
import { LoginComponent } from './components/login/login.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ConfirmationDialogeComponent } from './Genric/confirmation-dialoge/confirmation-dialoge.component';
import { CustomDatePipePipe } from './Pipes/custom-date-pipe.pipe';
// import { TestingComponent } from './components/testing/testing.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxPaginationModule } from 'ngx-pagination';
import { PeginationComponent } from './Genric/pegination/pegination.component';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { BookingCanvasComponent } from './Genric/booking-canvas/booking-canvas.component';
import { AuthInterceptor } from './auth.interceptor';
import { TripDurationPipe } from './Pipes/trip-duration.pipe';
import { CancellationReasonsComponent } from './components/cancellation-reasons/cancellation-reasons.component';




@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    LayoutComponent,
    BookingComponent,
    UserComponent,
    FinanceOverviewComponent,
    HelpsupportComponent,
    SettingsComponent,
    PersonaldetailsComponent,
    ContenManagerComponent,
    SubsettingComponent,
    NotificationsComponent,
    PreferenceComponent,
    SecurityComponent,
    LoginComponent,
    ConfirmationDialogeComponent,
    CustomDatePipePipe,
    // TestingComponent,
    PeginationComponent,
    BookingCanvasComponent,
    TripDurationPipe,
    CancellationReasonsComponent


    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    FormsModule,
    NgChartsModule,
    NgOtpInputModule,
    HttpClientModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    PickerModule,
    
     NgxPaginationModule,
       DragDropModule
    
    
    
    
  ],
  providers: [
     {
      provide: HTTP_INTERCEPTORS, 
      useClass: AuthInterceptor, 
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
